import * as commonData from "../Common";
import * as actionType from "../constants";
export const removeFilter = (input) => async (dispatch) => {
  let apiUrl = commonData.commonData().apiUrl;
  const response = await fetch(`${apiUrl}delete-custom-filter`, {
    method: "POST",
    body: JSON.stringify({ filter_id: input }),
  });

  const responseData = await response.json();
  if (responseData.code === 200) {
    dispatch({
      type: actionType.DELETE_FILTER,
      payload: {
        filter_id: input,
        message: responseData.message,
        code: responseData.code,
      },
    });
  } else {
    dispatch({
      type: actionType.DELETE_FILTER_ERROR,
      payload: { message: responseData.message, code: responseData.code },
    });
  }
};
